import { render, staticRenderFns } from "./CorpSalesTestimonial.vue?vue&type=template&id=d344b01a&scoped=true&"
import script from "./CorpSalesTestimonial.vue?vue&type=script&lang=js&"
export * from "./CorpSalesTestimonial.vue?vue&type=script&lang=js&"
import style0 from "./CorpSalesTestimonial.vue?vue&type=style&index=0&id=d344b01a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d344b01a",
  null
  
)

export default component.exports